import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("xpertrecruit_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      // Payment required : redirect to pricing
      if (!window.location.pathname.startsWith("/pricing") && !window.location.pathname.startsWith("/billing")) {
        window.location.href = "/pricing?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
